import React from 'react';

import OuiNonToggle from '../fermer-enregistrement-capture/oui-non-toggle.js';

import CaptureDetailsTable from '../fermer-enregistrement-capture/capture-details-table.js';

import {
    estQuestionAutreGibierResolue,
    montrerQuestionAutreGibierRound,
    obtenirReponseAutreGibierRound,
    doitAfficherSaisieGibierActive,
} from '../../utils/fermer-enregistrement-chasse-capture.js';

import { obtenirIdsRoundsBloc } from '../../utils/fermer-enregistrement-capture.js';

const hasPositiveCount = (value) => Number(value) > 0;

const SecteurSection = ({
    texts,
    index,
    block,
    secteursDisponibles,
    isFirst,
    showAutreSecteur,
    onSecteurChange,
    onNombrePersonnesChange,
    onNombreJoursChange,
    onPrisesChange,
    onCaptureDetailChange,
    onAutreGibierChange,
    onGibierChange,
    onAutreSecteurChange,
}) => {
    const secteurLabel = isFirst
        ? texts.secteurFirst
        : texts.secteurOther;

    const showNombreJours = block.idSecteur && hasPositiveCount(block.nombrePersonnes);
    const afficherQuestionPrises = showNombreJours && (
        hasPositiveCount(block.nombreJours) || block.aEuDesPrises !== null
    );
    const canShowAutreSecteur = showAutreSecteur && estQuestionAutreGibierResolue(block);
    const excludedGibierIds = obtenirIdsRoundsBloc(block);
    const captureTexts = {
        ...texts,
        captureInstruction: texts.captureInstructionChasse,
        noEspece: texts.noGibier,
    };
    const especeRounds = block.especeRounds || [];
    const showActiveGibierCapture = doitAfficherSaisieGibierActive(block);

    const activeGibierCaptureTable = showActiveGibierCapture &&
        <CaptureDetailsTable
            mode="chasse"
            texts={captureTexts}
            capturesDetails={block.capturesDetails}
            excludeSpeciesIds={excludedGibierIds}
            resetSelectionKey={excludedGibierIds.join('|')}
            activeSpeciesId={block.activeEspeceId || ''}
            showInstruction={especeRounds.length === 0}
            onSpeciesChange={gibierId => onGibierChange(index, gibierId)}
            onDetailChange={(detailIndex, field, value, extraUpdates) =>
                onCaptureDetailChange(index, detailIndex, field, value, extraUpdates)
            }
        />;

    return (
        <div className="fec-point-eau-section">
            <div className="sub-title-section">
                <span className="droit-acces-span">{secteurLabel}</span>
            </div>
            <select
                className="fec-select droit-acces-input"
                value={block.idSecteur || ''}
                onChange={e => onSecteurChange(index, e.target.value)}
            >
                <option value="">{texts.chooseOption}</option>
                {secteursDisponibles.map(s => (
                    <option key={s.idSecteur} value={s.idSecteur}>
                        {s.nomSecteur || s.NomSecteur}
                    </option>
                ))}
            </select>

            {block.idSecteur &&
                <>
                    <div className="sub-title-section">
                        <span className="droit-acces-span">{texts.nombrePersonnesChasse}</span>
                    </div>
                    <input
                        type="number"
                        min="1"
                        className="fec-number-input droit-acces-input"
                        value={block.nombrePersonnes}
                        onChange={e => onNombrePersonnesChange(index, e.target.value)}
                        onWheel={(e) => e.currentTarget.blur()}
                    />

                    {showNombreJours &&
                        <>
                            <div className="sub-title-section">
                                <span className="droit-acces-span">{texts.nombreJoursChasse}</span>
                            </div>
                            <input
                                type="number"
                                min="1"
                                className="fec-number-input droit-acces-input"
                                value={block.nombreJours}
                                onChange={e => onNombreJoursChange(index, e.target.value)}
                                onWheel={(e) => e.currentTarget.blur()}
                            />
                        </>
                    }

                    {afficherQuestionPrises &&
                        <OuiNonToggle
                            texts={texts}
                            label={texts.prisesQuestionChasse}
                            value={block.aEuDesPrises}
                            onChange={value => onPrisesChange(index, value)}
                        />
                    }

                    {block.aEuDesPrises === true &&
                        <div className="fec-capture-flow">
                            {especeRounds.map((round, roundIndex) =>
                                <React.Fragment key={`gibier-round-${round.speciesId}`}>
                                    <CaptureDetailsTable
                                        mode="chasse"
                                        texts={captureTexts}
                                        capturesDetails={block.capturesDetails}
                                        lockSpeciesDropdown={true}
                                        lockedSpeciesId={round.speciesId}
                                        showInstruction={false}
                                        onDetailChange={(detailIndex, field, value, extraUpdates) =>
                                            onCaptureDetailChange(index, detailIndex, field, value, extraUpdates)
                                        }
                                    />

                                    {montrerQuestionAutreGibierRound(block, roundIndex) &&
                                        <OuiNonToggle
                                            texts={texts}
                                            label={texts.autreGibierQuestion}
                                            value={obtenirReponseAutreGibierRound(block, roundIndex)}
                                            onChange={value => onAutreGibierChange(index, value, roundIndex)}
                                        />
                                    }
                                </React.Fragment>
                            )}

                            {activeGibierCaptureTable}
                        </div>
                    }

                    {block.aEuDesPrises !== null && canShowAutreSecteur &&
                        <OuiNonToggle
                            texts={texts}
                            label={texts.autreSecteur}
                            value={block.autreSecteur}
                            onChange={value => onAutreSecteurChange(index, value)}
                        />
                    }
                </>
            }
        </div>
    );
};

export default SecteurSection;
